import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRewind = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 17L11.2 12L16 7M8 7V17",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgRewind);
export { ForwardRef as ReactComponent };
